import React from 'react';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined'
import ArrowUpwardOutlinedIcon from '@material-ui/icons/ArrowUpwardOutlined'
import AutorenewOutlinedIcon from '@material-ui/icons/AutorenewOutlined'
import ChatOutlinedIcon from '@material-ui/icons/ChatOutlined'
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined'
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined'
import HistoryOutlinedIcon from '@material-ui/icons/HistoryOutlined'
import LockOpenOutlinedIcon from '@material-ui/icons/LockOpenOutlined'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import CloseIcon from '@material-ui/icons/Close';
import PersonAddOutlinedIcon from '@material-ui/icons/PersonAddOutlined'
import RotateRightOutlinedIcon from '@material-ui/icons/RotateRightOutlined'
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined'

/**
 * Gets the icon and background color for an audit trail operation
 * @param {Object} params - Parameters object
 * @param {string} params.operation - The operation type
 * @param {string} params.formName - The form name
 * @param {string} params.formType - The form type
 * @returns {Object} - Object containing icon component and bgColor
 */
export const getIcon = ({ operation, formName, formType }) => {
  let icon
  let bgColor

  switch (true) {
    case operation === 'process':
      bgColor = '#7A00FF'
      icon = <SettingsOutlinedIcon />
      break

    case operation === 'Created':
      bgColor = '#7A00FF'
      icon = <SettingsOutlinedIcon />
      break

    case operation === 'Accept':
      bgColor = '#27B47C'
      icon = <CheckOutlinedIcon />
      break

    case operation === 'Complete':
      bgColor = '#27B47C'
      icon = <CheckOutlinedIcon />
      break

    case operation === 'Modify' &&
      formName === 'workflow' &&
      formType === 'Init':
      bgColor = '#3082AA'
      icon = <RotateRightOutlinedIcon />
      break

    case operation === 'Modify' &&
      formName === 'workflow' &&
      formType === 'ReInit':
      bgColor = '#0095FF'
      icon = <AutorenewOutlinedIcon />
      break

    case operation === 'Modify' &&
      formName === 'workflow' &&
      formType === 'Comment':
      bgColor = '#8E8E8E'
      icon = <ChatOutlinedIcon />
      break

    case operation === 'Modify' &&
      formName === 'workflow' &&
      formType === 'Execute':
      bgColor = '#27B47C'
      icon = <CheckOutlinedIcon />
      break

    case operation === 'Modify' &&
      formName === 'workflow' &&
      formType === 'Reject':
      bgColor = '#F52F55'
      icon = <ClearOutlinedIcon />
      break

    case operation === 'Update':
      bgColor = '#ED6A30'
      icon = <EditOutlinedIcon />
      break

    case operation === 'Assign document':
      bgColor = '#FEAD2C'
      icon = <PersonAddOutlinedIcon />
      break

    case operation === 'Moved':
      bgColor = '#523FFF'
      icon = <ArrowForwardOutlinedIcon />
      break

    case operation === 'Upload':
      bgColor = '#FF3FEC'
      icon = <ArrowUpwardOutlinedIcon />
      break

    case operation === 'filesplit':
      bgColor = '#BF00FF'
      icon = <FileCopyOutlinedIcon />
      break

    case operation === 'UnLocked':
      bgColor = '#27B47C'
      icon = <LockOpenOutlinedIcon />
      break

    case operation === 'Restore':
      bgColor = '#C7317E'
      icon = <HistoryOutlinedIcon />
      break

    case operation === 'Locked':
      bgColor = '#526172'
      icon = <LockOutlinedIcon />
      break

    case operation === 'Delete':
      bgColor = '#FE2C2C'
      icon = <CloseIcon />
      break

    default:
      bgColor = '#f5f5f5'
      icon = '🔄'
  }

  return {
    icon,
    bgColor
  }
}

/**
 * Gets the operation icon path for SVG icons
 * @param {string} formName - The form name
 * @param {string} operation - The operation type
 * @param {string} formType - The form type
 * @returns {string} - Path to the SVG icon
 */
export const getOperationIcon = (formName, operation, formType) => {
  const operationIcons = {
    Created: '/media/svg/AddTaskObligationAudit.svg',
    taskCreated: '/media/svg/AddTaskObligationAudit.svg',
    Accept: '/media/svg/tickObligations.svg',
    "Assign document": '/media/svg/assignedObligationAudit.svg',
    assigned: '/media/svg/assignedObligationAudit.svg',
    deleted: '/media/svg/deleteTaskAudit.svg',
    taskUpdated: '/media/svg/editObligationAudit.svg',
    forwarded: '/media/svg/forwardObligationAudit.svg',
    messaged: '/media/svg/messageObligationAudit.svg',
    Modify: '/media/svg/moveObligationsAudit.svg',
    rejectObligation: '/media/svg/tickObligations.svg',
    taskDelete: '/media/svg/deleteTaskAudit.svg',
  };

  if (operation === 'Modify' && formType === "Reject") {
    return operationIcons["rejectObligation"]
  }
  if (formName === "workflow" && formType === "Comment") {
    return operationIcons["messaged"]
  }
  return operationIcons[operation];
}
